import axios from "axios";
import { ApiConfig } from "../Config/config";


const refreshInstance = axios.create(); // no interceptors

const attachRequestInterceptor = async (config) => {
    let [role] = config.url.split("/");
    let defaultToken = ApiConfig.defaultToken;

    if (role === "super_admin") {
        defaultToken = ApiConfig.defaultSuperAdmin;
    } else if (role === "customer") {
        defaultToken = ApiConfig.defaultToken;
    } else if (role === "fuel_vendor") {
        defaultToken = ApiConfig.defaultFuelAdmin;
    } else if (role === "admin") {
        defaultToken = ApiConfig.defaultAdmin;
    }


    const token = sessionStorage.getItem("token") || defaultToken;
    const refreshToken = sessionStorage.getItem("refreshToken");
    const staticKeyAPI = ["verifyOtp", "changePassword", "resetPassword", "checkVendorOwner", "changeEmailOrPhone", "checkCustomer", "ordStatus", "verifyRecaptcha"];
    const pdfAPI = ["generateInvoice"];
    const FIVE_MINUTES_IN_MS = 5 * 60 * 1000;

    // Static APIs
    if (staticKeyAPI.some((key) => config.url.includes(key))) {
        config.headers.Authorization = defaultToken;
        return config;
    }

    config.headers.Authorization = token;

    // if (token && token !== ApiConfig.defaultToken) {
    //     try {
    //         const { exp } = jwtDecode(token);
    //         console.log("exp", exp);
    //         const isExpiringSoon = exp * 1000 - Date.now() <= FIVE_MINUTES_IN_MS;
    //         console.log("isExpiringSoon", isExpiringSoon);

    //         const expiryDate = new Date(exp * 1000);
    //         console.log("Expiry Date:", expiryDate.toLocaleString()); 

    //         if (isExpiringSoon && refreshToken) {
    //             try {
    //                 const response = await refreshInstance.post(
    //                     `${ApiConfig.baseUrl}refreshToken`,
    //                     { token: refreshToken },
    //                     { headers: { Authorization: token } }
    //                 );

    //                 const newAccessToken = response?.data?.data?.accessToken;
    //                 if (newAccessToken) {
    //                     sessionStorage.setItem("token", newAccessToken);
    //                     config.headers.Authorization = newAccessToken;
    //                 }
    //             } catch (error) {
    //                 console.error("Error refreshing token:", error);
    //                   if (!window.__redirecting) {
    //                     window.__redirecting = true;
    //                     sessionStorage.clear();
    //                     window.location.href = "/login"; // or navigate("/login")
    //                   }
    //                   return Promise.reject(error);
    //             }
    //         }
    //     } catch (err) {
    //         console.error("Invalid token:", err);
    //         //   if (!window.__redirecting) {
    //         //     window.__redirecting = true;
    //         //     sessionStorage.clear();
    //         //     window.location.href = "/login";
    //         //   }
    //         //   return Promise.reject(err);
    //     }
    // }

    if (config.data instanceof FormData) {
        config.headers["Content-Type"] = "multipart/form-data";
    }

    if (pdfAPI.some((key) => config.url.includes(key))) {
        config.responseType = "blob";
        config.headers["Content-Type"] = "application/pdf";
    }

    return config;
};

export { attachRequestInterceptor };